import moment from 'jalali-moment';
import {useEffect, useState} from "react";

const DatePicker = ({onComplete,onError,initialDate=''}) => {
    const now = moment();
    const currentYear = +now.format('jYYYY');
    const monthList = [
        'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
    ];
    const initDate = initialDate?.split('/') ||[];

    const yearsArray = Array.from({length: 101}, (_, index) => currentYear - index);
    //-------------------------------------
    const dayList = [...Array(31).keys()].map(i => i + 1);
    const [year, setYear] = useState(initDate.length===3 ? +initDate[0]:null);
    const [month, setMonth] = useState(initDate.length===3 ? +initDate[1]:null);
    const [day, setDay] = useState(initDate.length===3 ? +initDate[2]:null);
    useEffect(() => {


        if (onComplete && day>0 && month>0 && year>0) {
            let m = month < 10 ? '0' + month : month;
            let d =  day < 10 ? '0' + day : day;

            onComplete(year + '/' + m + '/' + d)
        }else {
            onError('')
        }

    }, [day, year, month])
    const handleChangeYear = (e) => {
        setYear(e.target.value)
    }
    const handleDay = (e) => {
        setDay(e.target.value)
    }
    const handleMonth = (e) => {
        setMonth(e.target.value)
    }
    return <div className="grid grid-cols-3  w-full gap-2 p-1 ">

        <div className="flex items-start justify-start flex-col">

            <select value={day} onChange={handleDay}
                    className="py-2 px-3 w-full bg-gray-100 text-sm text-gray-700 rounded-lg border"
                    placeholder="روز"
                    name="day" id="">
                <option value={0}>روز</option>
                {
                    dayList.map((item, index) => <option  key={'day' + index} value={index + 1}>{item}</option>)
                }

            </select>
        </div>
        <div className="flex items-start justify-start flex-col">

            <select value={month} onChange={handleMonth}
                    className="py-2 w-full px-3 bg-gray-100 text-sm text-gray-700 rounded-lg border"
                    placeholder="ماه"
                    name="year" id="">
                <option value={0}>ماه</option>
                {

                    monthList.map((item, index) => <option  key={'month' + index} value={index + 1}>{item}</option>)
                }

            </select>
        </div>
        <div className="flex  items-start justify-start flex-col">

            <select value={year} onChange={handleChangeYear}
                    className="py-2 px-3 w-full text-sm text-gray-700 bg-gray-100 rounded-lg border" placeholder="سال"
                    name="year" id="">
                <option value={0}>سال</option>
                {
                    yearsArray.map((item, index) => <option  className="text-sm text-gray-700" key={'year' + index}
                                                            value={item}>{item}</option>)
                }


            </select>
        </div>


    </div>
}
export default DatePicker;